import { LearnwareInstance } from '../../learnware/LearnwareEnums';
import { str_replace } from '../../../utils/helper/helper_string';
import { round } from '../../../utils/helper/lodash_replacements';
export function calculateGradeInner(pointsDividedByMaxpoints_pass, averageRelativeUserKnowledge, relativeKnowledgeDistribution, instance = LearnwareInstance.AbfragerDE) {
    // pointsDividedByMaxpoints:     avg(points/maxpoints) of user for questions the user has answered
    // averageRelativeUserKnowledge:     avg(points/maxpoints) - avg(average) >> attribute "average" of getQuestion for questions the user has answered
    // relativeKnowledgeDistribution:     see attribute of getModules
    // absolute points
    // http://www.schmohl.eu/schule/Website/Schule_files/ProzentNoten-Details.pdf
    let pointsDividedByMaxpoints = pointsDividedByMaxpoints_pass;
    if (isNaN(pointsDividedByMaxpoints))
        pointsDividedByMaxpoints = 0;
    const grade1 = calculateRawAbsoluteInnerGrade(pointsDividedByMaxpoints);
    if (!relativeKnowledgeDistribution || relativeKnowledgeDistribution.length === 0) {
        return grade1;
    }
    const grade2 = calculateRawRelativeInnerGrade(pointsDividedByMaxpoints, averageRelativeUserKnowledge, relativeKnowledgeDistribution, instance);
    let grade = round((grade1 + grade2) / 2, 1);
    if (pointsDividedByMaxpoints >= 0.98) {
        grade = 1.0;
    }
    if (instance === LearnwareInstance.AbfragerCH) {
        grade = 7 - grade;
    }
    if (instance === LearnwareInstance.AbfragerAT) {
        if (grade > 5) {
            grade = 5;
        }
    }
    return grade;
}
export function calculateRawRelativeInnerGrade(pointsDividedByMaxpoints, averageRelativeUserKnowledge, relativeKnowledgeDistribution, instance = LearnwareInstance.AbfragerDE) {
    // relative places
    const r = [
        6.0,
        6.0,
        5.9,
        5.8,
        5.65,
        5.5,
        5.3,
        5.2,
        5.0,
        4.8,
        4.7,
        4.6,
        4.5,
        4.4,
        4.3,
        4.2,
        4.1,
        4.1,
        4.0,
        4.0,
        3.9,
        3.9,
        3.8,
        3.8,
        3.7,
        3.7,
        3.6,
        3.6,
        3.5,
        3.5,
        3.4,
        3.4,
        3.3,
        3.3,
        3.3,
        3.2,
        3.2,
        3.2,
        3.1,
        3.1,
        3.1,
        3.0,
        3.0,
        3.0,
        3.0,
        2.9,
        2.9,
        2.9,
        2.8,
        2.8,
        2.8,
        2.7,
        2.7,
        2.7,
        2.6,
        2.6,
        2.6,
        2.5,
        2.5,
        2.5,
        2.4,
        2.4,
        2.4,
        2.3,
        2.3,
        2.3,
        2.2,
        2.2,
        2.2,
        2.2,
        2.1,
        2.1,
        2.1,
        2.0,
        2.0,
        2.0,
        1.9,
        1.9,
        1.9,
        1.8,
        1.8,
        1.7,
        1.7,
        1.6,
        1.6,
        1.5,
        1.5,
        1.4,
        1.4,
        1.3,
        1.3,
        1.2,
        1.2,
        1.1,
        1.1,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
    ];
    let place = 1;
    while (place <= 99 && averageRelativeUserKnowledge > relativeKnowledgeDistribution[place - 1]) {
        place = place + 1;
    }
    return r[place - 1];
}
export function calculateRawAbsoluteInnerGrade(pointsDividedByMaxpoints) {
    if (isNaN(pointsDividedByMaxpoints))
        return 6;
    const p = [
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        5.9,
        5.8,
        5.8,
        5.8,
        5.7,
        5.7,
        5.6,
        5.6,
        5.5,
        5.5,
        5.4,
        5.3,
        5.3,
        5.2,
        5.2,
        5.1,
        5.1,
        5.0,
        5.0,
        5.0,
        4.9,
        4.9,
        4.8,
        4.8,
        4.7,
        4.7,
        4.6,
        4.6,
        4.5,
        4.5,
        4.3,
        4.3,
        4.2,
        4.2,
        4.1,
        4.1,
        4.0,
        4.0,
        3.9,
        3.9,
        3.8,
        3.8,
        3.7,
        3.7,
        3.6,
        3.6,
        3.5,
        3.5,
        3.4,
        3.4,
        3.4,
        3.3,
        3.2,
        3.2,
        3.1,
        3.1,
        3.0,
        3.0,
        2.9,
        2.9,
        2.8,
        2.8,
        2.7,
        2.6,
        2.6,
        2.5,
        2.5,
        2.4,
        2.4,
        2.3,
        2.2,
        2.2,
        2.1,
        2.1,
        2.0,
        1.9,
        1.9,
        1.8,
        1.8,
        1.7,
        1.7,
        1.6,
        1.5,
        1.4,
        1.3,
        1.2,
        1.1,
        1.0,
        1.0,
        1.0,
        1.0,
    ];
    return p[Math.round(pointsDividedByMaxpoints * 100)];
}
export function calculateAverageGrade(averageKnowledge, instance = LearnwareInstance.AbfragerDE) {
    // averageKnowledge: average of attribute "average" of getQuestion for questions the user has answered
    const p = [
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        6.0,
        5.9,
        5.8,
        5.8,
        5.8,
        5.7,
        5.7,
        5.6,
        5.6,
        5.5,
        5.5,
        5.4,
        5.3,
        5.3,
        5.2,
        5.2,
        5.1,
        5.1,
        5.0,
        5.0,
        5.0,
        4.9,
        4.9,
        4.8,
        4.8,
        4.7,
        4.7,
        4.6,
        4.6,
        4.5,
        4.5,
        4.3,
        4.3,
        4.2,
        4.2,
        4.1,
        4.1,
        4.0,
        4.0,
        3.9,
        3.9,
        3.8,
        3.8,
        3.7,
        3.7,
        3.6,
        3.6,
        3.5,
        3.5,
        3.4,
        3.4,
        3.4,
        3.3,
        3.2,
        3.2,
        3.1,
        3.1,
        3.0,
        3.0,
        2.9,
        2.9,
        2.8,
        2.8,
        2.7,
        2.6,
        2.6,
        2.5,
        2.5,
        2.4,
        2.4,
        2.3,
        2.2,
        2.2,
        2.1,
        2.1,
        2.0,
        1.9,
        1.9,
        1.8,
        1.8,
        1.7,
        1.7,
        1.6,
        1.5,
        1.4,
        1.3,
        1.2,
        1.1,
        1.0,
        1.0,
        1.0,
        1.0,
    ];
    const grade1 = p[Math.round(averageKnowledge * 100)];
    // average of relative calculation is always 2.9225
    const grade2 = 2.9225;
    let average = round((grade1 + grade2) / 2, 1);
    if (instance === LearnwareInstance.AbfragerCH) {
        average = 7 - average;
    }
    if (instance === LearnwareInstance.AbfragerAT) {
        if (average > 5) {
            average = 5;
        }
    }
    return average;
}
export function calculateUserPlace(averageRelativeUserKnowledge, relativeKnowledgeDistribution) {
    let place = 100;
    if (relativeKnowledgeDistribution && relativeKnowledgeDistribution.length > 0) {
        let user_index = 1;
        for (let j = 0; j < 99; j = j + 1) {
            if (averageRelativeUserKnowledge >= relativeKnowledgeDistribution[j]) {
                user_index = user_index + 1;
            }
        }
        place = 101 - user_index;
    }
    return place;
}
export function numericGradeToString(grade) {
    if (!grade)
        return '';
    return str_replace('.', ',', grade.toFixed(1));
}
